import { MESSAGES_WORKER_EVENT_TYPES } from './components/messages/messages.const';
import { processLoadThreads } from './workers/messages/processEvents';
onmessage = function (event) {
    if (!event.data.type) {
        return;
    }
    const type = event.data.type;
    switch (type) {
        case MESSAGES_WORKER_EVENT_TYPES.LOAD_THREADS:
            processLoadThreads(event.data.jobId).then(data => {
                postMessage({ type: MESSAGES_WORKER_EVENT_TYPES.THREADS_LOADED, data });
            });
            break;
    }
};
